<template>
    <div>
        <header class="d-flex align-items-center">
            <h5>Notifications</h5>
            <b-btn variant="ghost ml-2 p-0 d-none" v-b-popover.hover="'Lorem ipsum dolor sit amet'" title="">
                <i class="ic-tooltip"></i>
            </b-btn>
        </header>
        <div class="modal-form mt-3">
            <b-form>
                <table id="notif_settings" class="table b-table mt-4 mb-5">
                    <thead class="shadow-none">
                        <tr>
                            <th class="border-right border-top-0"></th>
                            <th class="border-right border-bottom border-top-0 px-0 pb-0">
                                <span class="px-2 mb-2 d-inline-flex">Transaction</span>
                                <table class="table b-table m-0 w-100">
                                    <thead>
                                        <tr>
                                            <th class="border-top-0 pt-0">Notify Me</th>
                                            <th class="border-top-0 pt-0">Limit</th>
                                            <th class="border-top-0 pt-0">Frequency</th>
                                        </tr>
                                    </thead>
                                </table>
                            </th>
                            <th class="border-bottom border-top-0 px-0 pb-0">
                                <span class="px-2 mb-2 d-inline-flex">Amount</span>
                                <table class="table b-table m-0 w-100">
                                    <thead>
                                        <tr>
                                            <th class="border-top-0 pt-0">Notify Me</th>
                                            <th class="border-top-0 pt-0">Limit</th>
                                            <th class="border-top-0 pt-0">Frequency</th>
                                        </tr>
                                    </thead>
                                </table>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="text-right bg-light border-right align-middle">Earn</td>
                            <td class="border-bottom border-right p-0">
                                <table class="table b-table m-0 w-100">
                                    <thead>
                                        <th class="d-none"></th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="border-0">
                                                <switches
                                                    v-model="form.notification_settings.transaction.earn.notify_me"
                                                    theme="custom"
                                                    color="primary"
                                                    type-bold="true"
                                                    class="m-0 pt-3">
                                                </switches>
                                            </td>
                                            <td class="border-0">
                                                <b-form-group
                                                    :invalid-feedback="errorMessage('update_notification.3.limit')"
                                                    :state="isValid('update_notification.3.limit')">
                                                    <b-form-input type="number" min="1"
                                                        v-model="form.notification_settings.transaction.earn.limit"
                                                        :disabled="form.notification_settings.transaction.earn.notify_me == 0"
                                                        @keyup.native="isAllowed()">
                                                    </b-form-input>
                                                </b-form-group>
                                            </td>
                                            <td class="border-0">
                                                <b-form-select id="earn_frequency"
                                                    :options="frequency"
                                                    v-model="form.notification_settings.transaction.earn.frequency"
                                                    :disabled="form.notification_settings.transaction.earn.notify_me == 0">
                                                </b-form-select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                            <td class="border-bottom p-0">
                                <table class="table b-table m-0 w-100">
                                    <thead>
                                        <th class="d-none"></th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="border-0">
                                                <switches
                                                    v-model="form.notification_settings.amount.earn.notify_me"
                                                    theme="custom"
                                                    color="primary"
                                                    type-bold="true"
                                                    class="m-0 pt-3">
                                                </switches>
                                            </td>
                                            <td class="border-0">
                                                <b-form-group
                                                    :invalid-feedback="errorMessage('update_notification.0.limit')"
                                                    :state="isValid('update_notification.0.limit')">
                                                    <b-form-input type="number" min="1"
                                                        v-model="form.notification_settings.amount.earn.limit"
                                                        :disabled="form.notification_settings.amount.earn.notify_me == 0"
                                                        @keyup.native="isAllowed()">
                                                    </b-form-input>
                                                </b-form-group>
                                            </td>
                                            <td class="border-0">
                                                <b-form-select id="earn_frequency"
                                                    :options="frequency"
                                                    v-model="form.notification_settings.amount.earn.frequency"
                                                    :disabled="form.notification_settings.amount.earn.notify_me == 0">
                                                </b-form-select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-right bg-light border-right align-middle">Transfer Points</td>
                            <td class="border-bottom border-right p-0">
                                <table class="table b-table m-0 w-100">
                                    <thead>
                                        <th class="d-none"></th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="border-0">
                                                <switches
                                                    v-model="form.notification_settings.transaction.transfer.notify_me"
                                                    theme="custom"
                                                    color="primary"
                                                    type-bold="true"
                                                    class="m-0 pt-3">
                                                </switches>
                                            </td>
                                            <td class="border-0">
                                                <b-form-group
                                                    :invalid-feedback="errorMessage('update_notification.4.limit')"
                                                    :state="isValid('update_notification.4.limit')">
                                                    <b-form-input type="number" min="1"
                                                        v-model="form.notification_settings.transaction.transfer.limit"
                                                        :disabled="form.notification_settings.transaction.transfer.notify_me == 0"
                                                        @keyup.native="isAllowed()">
                                                    </b-form-input>
                                                </b-form-group>
                                            </td>
                                            <td class="border-0">
                                                <b-form-select id="earn_frequency"
                                                    :options="frequency"
                                                    v-model="form.notification_settings.transaction.transfer.frequency"
                                                    :disabled="form.notification_settings.transaction.transfer.notify_me == 0">
                                                </b-form-select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                            <td class="border-bottom p-0">
                                <table class="table b-table m-0 w-100">
                                    <thead>
                                        <th class="d-none"></th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="border-0">
                                                <switches
                                                    v-model="form.notification_settings.amount.transfer.notify_me"
                                                    theme="custom"
                                                    color="primary"
                                                    type-bold="true"
                                                    class="m-0 pt-3">
                                                </switches>
                                            </td>
                                            <td class="border-0">
                                                <b-form-group
                                                    :invalid-feedback="errorMessage('update_notification.1.limit')"
                                                    :state="isValid('update_notification.1.limit')">
                                                    <b-form-input type="number" min="1"
                                                        v-model="form.notification_settings.amount.transfer.limit"
                                                        :disabled="form.notification_settings.amount.transfer.notify_me == 0"
                                                        @keyup.native="isAllowed()">
                                                    </b-form-input>
                                                </b-form-group>
                                            </td>
                                            <td class="border-0">
                                                <b-form-select id="earn_frequency"
                                                    :options="frequency"
                                                    v-model="form.notification_settings.amount.transfer.frequency"
                                                    :disabled="form.notification_settings.amount.transfer.notify_me == 0">
                                                </b-form-select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-right bg-light border-right border-bottom align-middle">Pay Point</td>
                            <td class="border-bottom border-right p-0">
                                <table class="table b-table m-0 w-100">
                                    <thead>
                                        <th class="d-none"></th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="border-0">
                                                <switches
                                                    v-model="form.notification_settings.transaction.pay.notify_me"
                                                    theme="custom"
                                                    color="primary"
                                                    type-bold="true"
                                                    class="m-0 pt-3">
                                                </switches>
                                            </td>
                                            <td class="border-0">
                                                <b-form-group
                                                    :invalid-feedback="errorMessage('update_notification.5.limit')"
                                                    :state="isValid('update_notification.5.limit')">
                                                    <b-form-input type="number" min="1"
                                                        v-model="form.notification_settings.transaction.pay.limit"
                                                        :disabled="form.notification_settings.transaction.pay.notify_me == 0"
                                                        @keyup.native="isAllowed()">
                                                    </b-form-input>
                                                </b-form-group>
                                            </td>
                                            <td class="border-0">
                                                <b-form-select id="earn_frequency"
                                                    :options="frequency"
                                                    v-model="form.notification_settings.transaction.pay.frequency"
                                                    :disabled="form.notification_settings.transaction.pay.notify_me == 0">
                                                </b-form-select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                            <td class="border-bottom p-0">
                                <table class="table b-table m-0 w-100">
                                    <thead>
                                        <th class="d-none"></th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="border-0">
                                                <switches
                                                    v-model="form.notification_settings.amount.pay.notify_me"
                                                    theme="custom"
                                                    color="primary"
                                                    type-bold="true"
                                                    class="m-0 pt-3">
                                                </switches>
                                            </td>
                                            <td class="border-0">
                                                <b-form-group
                                                    :invalid-feedback="errorMessage('update_notification.2.limit')"
                                                    :state="isValid('update_notification.2.limit')">
                                                    <b-form-input type="number" min="1"
                                                        v-model="form.notification_settings.amount.pay.limit"
                                                        :disabled="form.notification_settings.amount.pay.notify_me == 0"
                                                        @keyup.native="isAllowed()">
                                                    </b-form-input>
                                                </b-form-group>
                                            </td>
                                            <td class="border-0">
                                                <b-form-select id="earn_frequency"
                                                    :options="frequency"
                                                    v-model="form.notification_settings.amount.pay.frequency"
                                                    :disabled="form.notification_settings.amount.pay.notify_me == 0">
                                                </b-form-select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-right bg-light border-right border-bottom align-middle">Redemption</td>
                            <td class="border-bottom border-right p-0">
                                <table class="table b-table m-0 w-100">
                                    <thead>
                                        <th class="d-none"></th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="border-0">
                                                <switches
                                                    v-model="form.notification_settings.transaction.redeem.notify_me"
                                                    theme="custom"
                                                    color="primary"
                                                    type-bold="true"
                                                    class="m-0 pt-3">
                                                </switches>
                                            </td>
                                            <td class="border-0">
                                                <b-form-group
                                                    :invalid-feedback="errorMessage('update_notification.6.limit')"
                                                    :state="isValid('update_notification.6.limit')">
                                                    <b-form-input type="number" min="1"
                                                        v-model="form.notification_settings.transaction.redeem.limit"
                                                        :disabled="form.notification_settings.transaction.redeem.notify_me == 0"
                                                        @keyup.native="isAllowed()">
                                                    </b-form-input>
                                                </b-form-group>
                                            </td>
                                            <td class="border-0">
                                                <b-form-select id="earn_frequency"
                                                    :options="frequency"
                                                    v-model="form.notification_settings.transaction.redeem.frequency"
                                                    :disabled="form.notification_settings.transaction.redeem.notify_me == 0">
                                                </b-form-select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                            <td class="border-bottom p-0">
                            </td>
                        </tr>
                    </tbody>
                </table>
                <b-row class="mb-4">
                    <b-col md="4">
                        <b-form-group label="Add User Account" label-for="users" label-class="secondary-label" class="position-relative" id="usersGroup">
                            <b-input-group>
                                <b-input-group slot="prepend" class="border rounded-left px-2 d-flex align-items-center">
                                    <template v-if="is_search">
                                        <i class="ic-search"></i>
                                    </template>
                                    <template v-else>
                                        <b-button variant=" btn-remove shadow-none"
                                            @click="hideUserList"></b-button>
                                    </template>
                                </b-input-group>
                                <b-form-input v-model="user_search"
                                    placeholder="Add User"
                                    @focus.native="showUserList"
                                    autocomplete="off"></b-form-input>
                            </b-input-group>

                            <div id="user-list" ref="userList" class="position-absolute bg-white w-100 d-none">
                                <ul class="p-0 m-0 d-flex flex-column">
                                    <template v-if="loading">
                                        <li>Loading Users...</li>
                                    </template>
                                    <template v-else>
                                        <template v-if="user_list.length == 0">
                                            <li>No User(s) to add.</li>
                                        </template>
                                        <b-form-checkbox-group v-model="selected_user">
                                            <li v-for="(user, index) in user_list"
                                                :key="index"
                                                class="d-flex align-items-center border-bottom">
                                                <span class="flex-grow-1">
                                                    {{ user.firstname }} {{ user.lastname }}
                                                </span>
                                                <b-form-checkbox
                                                    name="notifyme"
                                                    :value="user.uuid"
                                                    unchecked-value="0"
                                                    class="mt-2 mx-0 mb-0 p-0">
                                                </b-form-checkbox>
                                            </li>
                                        </b-form-checkbox-group>
                                    </template>
                                    <template v-if="user_list.length > 0">
                                        <li class="action">
                                            <b-button type="button" variant="primary add-user w-100 py-2"
                                                @click="addUsers">
                                                Add Selected ({{ selected_user.length }})
                                            </b-button>
                                        </li>
                                        <li class="action">
                                            <b-button type="button" variant="default unselect-users w-100 py-2"
                                                @click="unselectUsers">Unselect All</b-button>
                                        </li>
                                    </template>
                                </ul>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
                <div class="data-container">
                    <b-table show-empty
                        :empty-text="(loading) ? 'Loading data' : 'No Data Available'"
                        :items="form.users"
                        :fields="fields"
                        id="users"
                        responsive>
                        <template slot="mobile" slot-scope="data">
                            <span class="d-flex align-items-center">
                                <span class="flex-grow-1">
                                    {{ data.item.mobile.no }}
                                </span>
                                <span>
                                    <code>test</code>
                                    <switches
                                        v-model="data.item.mobile.enabled"
                                        theme="custom"
                                        color="primary"
                                        type-bold="true"
                                        class="m-0 p-0"
                                        :disabled="isDisabled(data.index, 'mobile')">
                                    </switches>
                                </span>
                            </span>
                        </template>
                        <template slot="email" slot-scope="data">
                            <span class="d-flex align-items-center">
                                <span class="flex-grow-1">
                                    {{ data.item.email.address }}
                                </span>
                                <span>
                                    <switches
                                        v-model="data.item.email.enabled"
                                        theme="custom"
                                        color="primary"
                                        type-bold="true"
                                        class="m-0 p-0"
                                        :disabled="isDisabled(data.index, 'email')">
                                    </switches>
                                </span>
                            </span>
                        </template>
                        <template slot="action" slot-scope="data">
                            <b-button type="button" variant="remove" @click="removeUser({
                                index: data.index,
                                id: data.item.id
                            })"></b-button>
                        </template>
                    </b-table>
                </div>
                <b-row>
                    <b-col sm="12" md="2" class="mt-5">
                        <b-button :disabled="saving" size="lg" variant="primary" class="save-button btn-block" @click="saveNotifications">
                            {{ this.saving ? "Saving..." : "Save"}}
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </div>
        <RemoveUser
            :user="modal.remove_user.status"
            @removeUser="removeUserModal" />
    </div>
</template>

<script>
import { mapState } from "vuex";

import Switches from "vue-switches";

import RemoveUser from "./RemoveUser";

export default {
    name: "Notifications",
    components: {
        Switches,
        RemoveUser
    },
    computed: {
        ...mapState("mechanicsCapping", [
            "modal",
            "loading",
            "notification_capping",
            "users",
            "delete_users",
            "reload",
            "errors"
        ])
    },
    data() {
        return {
            form: {
                notification_settings: {
                    transaction: {
                        earn: {},
                        redeem: {},
                        transfer: {},
                        pay: {},
                    },
                    amount: {
                        earn: {},
                        pay: {},
                        transfer: {}
                    }
                },
                users: []
            },
            frequency: [
                { value: "30", text: "30 mins" },
                { value: "60", text: "1 hour" },
                { value: "120", text: "2 hours" },
                { value: "180",  text: "3 hours" }
            ],
            saving: false,
            user_search: "",
            is_search: true,
            fields: [
                {
                    key: "name",
                    sortable: true,
                    thClass: "text-left",
                    tdClass: "text-left"
                },
                {
                    key: "mobile",
                    sortable: false,
                    label: "Notify via Mobile No."
                },
                {
                    key: "email",
                    sortable: false,
                    label: "Notify via Email Address"
                },
                {
                    key: "action",
                    sortable: false,
                    tdClass: "text-center"
                }
            ],
            user_list: [],
            selected_user: [],
            added_users: [],
            user_modal: {
                status: false,
                index: null
            }
        };
    },
    created: function() {
        this.getNotificationCapping();
        this.getUserList();
    },
    methods: {
        saveNotifications: function() {
            let param = {};

            let notification_settings = this.form.notification_settings;

            let update_notification = [];

            let update_notification_amount = [
                {
                    id: notification_settings.amount.earn.id,
                    notify_me: notification_settings.amount.earn.notify_me / 1,
                    limit: notification_settings.amount.earn.limit,
                    frequency: notification_settings.amount.earn.frequency
                },
                {
                    id: notification_settings.amount.transfer.id,
                    notify_me: notification_settings.amount.transfer.notify_me / 1,
                    limit: notification_settings.amount.transfer.limit,
                    frequency: notification_settings.amount.transfer.frequency
                },
                {
                    id: notification_settings.amount.pay.id,
                    notify_me: notification_settings.amount.pay.notify_me / 1,
                    limit: notification_settings.amount.pay.limit,
                    frequency: notification_settings.amount.pay.frequency
                }
            ];

            update_notification_amount.forEach(update => {
                update_notification.push(update);
            });

            let update_notification_transaction = [
                {
                    id: notification_settings.transaction.earn.id,
                    notify_me: notification_settings.transaction.earn.notify_me / 1,
                    limit: notification_settings.transaction.earn.limit,
                    frequency: notification_settings.transaction.earn.frequency
                },
                {
                    id: notification_settings.transaction.transfer.id,
                    notify_me: notification_settings.transaction.transfer.notify_me / 1,
                    limit: notification_settings.transaction.transfer.limit,
                    frequency: notification_settings.transaction.transfer.frequency
                },
                {
                    id: notification_settings.transaction.pay.id,
                    notify_me: notification_settings.transaction.pay.notify_me / 1,
                    limit: notification_settings.transaction.pay.limit,
                    frequency: notification_settings.transaction.pay.frequency
                },
                {
                    id: notification_settings.transaction.redeem.id,
                    notify_me: notification_settings.transaction.redeem.notify_me / 1,
                    limit: notification_settings.transaction.redeem.limit,
                    frequency: notification_settings.transaction.redeem.frequency
                }
            ];

            update_notification_transaction.forEach(update => {
                update_notification.push(update);
            });

            let users = this.form.users.map(user => {
                return {
                    id: user.id ? user.id : null,
                    merchant_uuid: user.merchant_uuid,
                    name: user.name,
                    mobile_number: user.mobile.no,
                    notify_mobile: user.mobile.enabled / 1,
                    email: user.email.address,
                    notify_email: user.email.enabled / 1
                }
            });

            let existing_audiences = this.notification_capping.audiences.map(audience => {
                return audience.email;
            });

            let add_user_account = users.map(user => {
                return user;
            }).filter(user => !existing_audiences.includes(user.email));

            let delete_user_accounts = {
                "ids": this.delete_users
            };

            param["update_notification"] = update_notification;

            if (delete_user_accounts.ids.length > 0)  {
                param["delete_user_accounts"] = delete_user_accounts;
            }

            if (add_user_account.length > 0) {
                param["add_user_account"] = add_user_account;
            }

            let update_user_account = users.map(user => {
                return user;
            }).filter(user => existing_audiences.includes(user.email));

            if (update_user_account.length > 0) {
                param["update_user_account"] = update_user_account;
            }

            this.$store.commit("mechanicsCapping/setNotificationCapping", param);
            this.$store.commit("mechanicsCapping/setModal", {
                status: true,
                type: "save",
                sub_type: "notifications"
            });          
        },

        unselectUsers: function() {
            this.selected_user = [];
        },

        addUsers: async function() {
            await this.selected_user.filter((user) => {
                this.getUser(user);
            });

            this.$refs.userList.classList.add("d-none");
            this.user_search = "";
            this.selected_user = [];
            this.is_search = true;
        },

        getUser: function(value) {
            this.user_list.filter((user) => {
                if (user.uuid === value) {
                    this.added_users.push(user);
                }
            });
        },

        removeUser: function(param) {
            this.$store.commit("mechanicsCapping/setModal", {
                status: true,
                index: param.index,
                id: param.id,
                type: 'remove_user'
            });
        },

        showUserList: function() {
            this.is_search = false;
            this.$refs.userList.classList.remove("d-none");
        },

        hideUserList: function() {
            this.is_search = true;
            this.$refs.userList.classList.add("d-none");
        },

        isDisabled: function(index, switch_type) {
            let user = this.form.users[index];
            let status;
            switch (switch_type) {
                case "email":
                    status = Boolean(user[switch_type].enabled) && Boolean(!user["mobile"].enabled);
                    break;
                case "mobile":
                    status = Boolean(user[switch_type].enabled) && Boolean(!user["email"].enabled);
                    break;
                default:
                    status = false;
            }
            return status;
        },

        closeUserModal: function() {
            this.user_modal.status = false;
        },

        removeUserModal: function(index) {
            this.form.users.splice(index, 1);
            this.$store.commit("mechanicsCapping/setModal", {
                status: false,
                type: "remove_user",
                index: null
            });
        },

        getNotificationCapping: async function() {
            await this.$store.dispatch("mechanicsCapping/getNotificationCapping")
                .then(() => {
                    this.form.notification_settings.transaction.earn = this.notification_capping.transaction.earn;
                    this.form.notification_settings.transaction.redeem = this.notification_capping.transaction.redeem;
                    this.form.notification_settings.transaction.transfer = this.notification_capping.transaction.transfer;
                    this.form.notification_settings.transaction.pay = this.notification_capping.transaction.pay;
                    this.form.notification_settings.amount.earn = this.notification_capping.amount.earn;
                    this.form.notification_settings.amount.pay = this.notification_capping.amount.pay;
                    this.form.notification_settings.amount.transfer = this.notification_capping.amount.transfer;
                    let transform_users =  this.notification_capping.audiences.map(audience => {
                        return {
                            id: audience.id,
                            name: audience.name,
                            mobile: {
                                no: audience.mobile_number,
                                enabled: Boolean(audience.notify_mobile)
                            },
                            email: {
                                address: audience.email,
                                enabled: Boolean(audience.notify_email)
                            },
                            merchant_uuid: audience.merchant_uuid
                        }
                    });
                    this.form.users = transform_users;
                });
        },

        getUserList: async function() {
            await this.$store.dispatch("mechanicsCapping/getUsers")
                .then(() => {
                    this.user_list = this.users;
                });
        },

        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors[field];
        },

        isValid(field) {
            if (this.errors == null) {
                return null;
            }

            return !this.errors[field];
        },

        isAllowed(evt) {
            evt = (evt) || window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            let evt_val = parseInt(evt.target.value, 10);
            if (evt_val == "99999") {
                if (charCode != 8) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            } else if (evt_val > "99999") {
                evt.target.value = "99999";
            } else if (evt_val < "1") {
                evt.target.value = "1";
            }
        }
    },
    watch: {
        user_search: function(value) {
            this.$store.commit("mechanicsCapping/loading", false);
            this.$refs.userList.classList.remove("d-none");
            this.$store.dispatch("mechanicsCapping/getUsers", value)
                .then(() => {
                    this.user_list = this.users;
                });
        },

        added_users: function(addedUsers) {
            addedUsers.map((user) => {
                this.form.users.push({
                    name: user.firstname + " " + user.lastname,
                    mobile: {
                        no: user.mobile,
                        enabled: true
                    },
                    email: {
                        address: user.email,
                        enabled: true
                    },
                    merchant_uuid: user.merchant_uuid
                });
            });
        },

        "form.users": function(value) {
            let added_user_id = this.form.users.map(user => {
                return user.email.address;
            });

            let refresh_user_list = this.users.map(user => {
                return user;
            }).filter(user => !added_user_id.includes(user.email));

            this.user_list = refresh_user_list;

            if (value != []) {
                this.added_users = [];
            }
        },

        reload: async function(value) {
            if (value) {
                await this.getNotificationCapping()
                    .then(() => {
                        this.$store.commit("mechanicsCapping/setReload", false);
                    });
            }
        }
    }
};
</script>

